module.exports = __webpack_public_path__ + "static/img/87.14d8d2cf.jpg";